module.exports = __webpack_public_path__ + "static/media/local-business-banner-img.eb7ed106.png";